<template>
  <div>
    <template v-if="!loggedIn">
      <h1>Please log in first</h1>
    </template>

    <template v-if="loggedIn && !Management">
      <h1>Loading management API</h1>
    </template>

    <template v-if="loggedIn && Management">
      <h1>Profile Explorer</h1>

      <div v-if="views" id="webproperties">
        <v-text-field v-model="search" append-icon="search" placeholder="Filter results"></v-text-field>
        <v-data-table
          :rows-per-page-items="rowsPerPage"
          :headers="headers.properties"
          :items="views"
          :search="search"
        >
          <template slot="items" slot-scope="props">
            <!-- <router-link
              :to="`/accounts/${accountId}/properties/${propertyId}/profiles/${props.item.id}`"
              tag="tr"
            >-->
            <td>{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.id }}</td>
            <td class="text-xs-left">{{ props.item.kind }}</td>
            <td class="text-xs-left">{{ props.item.selfLink }}</td>
            <!-- </router-link> -->
          </template>
        </v-data-table>

        <v-btn id="fetchViews" v-if="!views.length" @click="fetchViews">Load views</v-btn>

        <!-- <v-btn
          id="downloadDimensions"
          :href="this.getDimensionsLink"
          download
        >Download dimensions overview</v-btn>-->

        <!-- <v-btn id="downloadMetrics" :href="this.getMetricsLink" download>Download Metric overview</v-btn> -->
      </div>
    </template>
  </div>
</template>

<script>
import store from "@/store.js";

export default {
  name: "Profiles-Overview",
  props: ["accountId", "propertyId"],
  data() {
    return {
      views: [],
      search: "",
      rowsPerPage: [
        15,
        25,
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
      ],
      headers: {
        properties: [
          {
            text: "View Name",
            align: "left",
            value: "name"
          },
          { text: "View ID", value: "id" },
          { text: "Kind", value: "kind" },
          { text: "Link", value: "link" }
        ]
      }
    };
  },
  computed: {
    Management() {
      return this.$store.state.google.management;
    },
    loggedIn() {
      return this.$store.state.auth.signedIn;
    },
    authParams() {
      return this.$store.state.auth.params;
    },
    getDimensionsLink() {
      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/accounts/${
          this.accountId
        }/webproperties/${this.propertyId}/dimensions${this.authParams};`;
      } else {
        return `/api/accounts/${this.accountId}/webproperties/${
          this.propertyId
        }/dimensions${this.authParams};`;
      }
    },
    getMetricsLink() {
      if (process.env.NODE_ENV === "development") {
        return `http://localhost:3000/accounts/${
          this.accountId
        }/webproperties/${this.propertyId}/metrics${this.authParams}`;
      } else {
        return `/api/accounts/${this.accountId}/webproperties/${
          this.propertyId
        }/metrics${this.authParams}`;
      }
    }
  },
  methods: {
    fetchViews() {
      this.Management.profiles
        .list({ accountId: this.accountId, webPropertyId: this.propertyId })
        .then(res => {
          if (res.status === 200) {
            this.views = res.result.items;
          }
        })
        .catch(err => console.error(err));
    }
  },
  mounted() {
    this.$store.dispatch("setNavigation", {
      account: this.accountId,
      webProperty: this.propertyId
    });
    if (this.Management && !this.views.length) this.fetchViews();
  },
  watch: {
    Management(newV, oldV) {
      if (!oldV && newV && this.views.length == 0) {
        this.fetchViews();
      }
    }
  }
};
</script>


<style scoped>
tr {
  cursor: pointer;
}
</style>
